import {Component, OnInit} from '@angular/core';
import {SettingsDataService} from '../settings-data.service';
import {Vehiclecontainer} from '../model/vehiclecontainer.model';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Point} from '../model/point.model';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
  loading = false;

  provider: String = 'NJT_BUS';
  vehicles: Vehiclecontainer;
  index = 0;
  vehicle: string;
  blockId: string;
  blockIdMessage: string = null;

  constructor(private http: HttpClient, public settingsDataService: SettingsDataService, private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
        if (params !== null && params !== undefined) {
          if (params['vehicle'] !== null && params['vehicle'] !== undefined) {
            this.vehicle = params['vehicle'];
            this.updateVehicle();
          } else if (params['blockId'] !== null && params['blockId'] !== undefined) {
            this.blockId = params['blockId'];
            this.updateBlockID();
          }
        }
      }
    );
  }


  ngOnInit() {
  }

  updateVehicle() {
    if (this.provider !== null && this.provider !== undefined && this.vehicle !== null && this.vehicle !== undefined) {
      this.reset();
      this.blockId = '';
      this.loading = true;

      // track vehicle and move
      this.http.get(`https://ShowMeMyCommute.com:5928` +
        `/getVehicle?vehicleId=${this.vehicle}&providerId=${this.provider}&mode=all`)
        .pipe(map(res => new Vehiclecontainer().deserialize(res)))
        .subscribe(vc => {
          this.vehicles = vc;
          this.index = this.vehicles.veh.length - 1;
          const point = new Point();
          point.lat = this.vehicles.veh[this.index].lat;
          point.lon = this.vehicles.veh[this.index].lon;

          this.settingsDataService.moveMapToPoint.emit(point);
          this.loading = false;
        }, err => {
          console.log(err);
          this.loading = false;
        });

    }
  }

  goFastLeft() {
    if (this.index > 5) {
      this.index -= 5;
      const point = new Point();
      point.lat = this.vehicles.veh[this.index].lat;
      point.lon = this.vehicles.veh[this.index].lon;

      this.settingsDataService.moveMapToPoint.emit(point);
    }
  }

  goFastRight() {
    if (this.vehicles !== undefined && this.vehicles !== null && this.index < this.vehicles.veh.length - 5) {
      this.index += 5;
      const point = new Point();
      point.lat = this.vehicles.veh[this.index].lat;
      point.lon = this.vehicles.veh[this.index].lon;

      this.settingsDataService.moveMapToPoint.emit(point);
    }
  }

  goLeft() {
    if (this.index > 0) {
      this.index--;
      const point = new Point();
      point.lat = this.vehicles.veh[this.index].lat;
      point.lon = this.vehicles.veh[this.index].lon;

      this.settingsDataService.moveMapToPoint.emit(point);
    }
  }

  goRight() {
    if (this.vehicles !== undefined && this.vehicles !== null && this.index < this.vehicles.veh.length - 1) {
      this.index++;
      const point = new Point();
      point.lat = this.vehicles.veh[this.index].lat;
      point.lon = this.vehicles.veh[this.index].lon;

      this.settingsDataService.moveMapToPoint.emit(point);
    }
  }

  goRecent() {
    if (this.vehicles !== undefined && this.vehicles !== null) {
      this.index = this.vehicles.veh.length - 1;
      const point = new Point();
      point.lat = this.vehicles.veh[this.index].lat;
      point.lon = this.vehicles.veh[this.index].lon;

      this.settingsDataService.moveMapToPoint.emit(point);
    }

  }

  getTime(): number {
    if (this.vehicles !== undefined && this.vehicles !== null) {
      return this.vehicles.veh[this.index].time;
    }
    return 0;
  }

  updateBlockID() {

    if (this.provider !== null && this.provider !== undefined && this.blockId !== null && this.blockId !== undefined) {
      this.reset();
      this.loading = true;
      this.vehicle = '';

      // track vehicle and move
      this.http.get(`https://ShowMeMyCommute.com:5928` +
        `/njt/findb?b=${this.blockId}`,
        {responseType: 'text'})
        .pipe(map(res => res))
        .subscribe(res => {
          if (res !== null && res !== undefined) {
            this.blockIdMessage = res.toString();
          }
          this.loading = false;
        }, err => {
          console.log(err);
          this.loading = false;
        });

    }

    this.reset();
    this.vehicle = '';
  }

  getData(): string {

    if (this.vehicles !== undefined && this.vehicles !== null) {
      return this.vehicles.veh[this.index].routeId + ' ' + this.vehicles.veh[this.index].blockId + ' ' + this.vehicles.veh[this.index].data;
    }
    return '';
  }

  private reset() {
    this.vehicles = null;
    this.index = 0;
    this.blockIdMessage = null;
  }
}
